module.exports = __webpack_public_path__ + "static/media/home_value_props.f0a23b26.jpg";